import React from 'react';

import CSSModule from './ShinroMainButtonArea.module.scss';

const ShinroMainButtonArea: React.FC = () => (
  <div className={CSSModule.ShinroMainButtonArea}>
    <div className={CSSModule.ShinroMainButtonArea__Subtitle}>
      ＼大学・短大・専門学校の情報満載／
    </div>
    <button className={CSSModule.ShinroMainButtonArea__Button}>
      お子さまの進学先を探す
    </button>
  </div>
);

export default ShinroMainButtonArea;
